<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"/>
  </div>
</template>
<script>
export default {
  name: 'App',
  provide () { // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true // 控制视图是否显示的变量
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false // 先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true // 再打开
      })
    }
  }
}
</script>
<style>
  html * {
    font-family: '思源黑体','黑体','Simhei','宋体','仿宋',sans-serif !important;
    box-sizing: border-box !important;
  }
  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  pre {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    display:inline;
    white-space: pre-wrap;
    margin: 0;
  }
  body {
    margin: 0px;
    background-color: #f6f7f8;
    box-sizing: border-box !important;
  }
  /* 隐藏滚动条 */
  body::-webkit-scrollbar {
    height: 0;
    width: 0;
    color: transparent;
  }
  /* 设置头部高度 */
  .el-header {
    /* height: 70px !important; */
    padding: 0px !important;
  }
  .el-main{
    padding: 20px 55px !important;
  }
  /* 全局设置表格表头样式 */
  thead tr:first-child th {
    background-color: #f7fbff;
  }
  /* 全局设置分页的样式 */
  .el-pagination {
    text-align: center;
    margin-top: 1%;
  }
  /* 所有a标签都没有下划线 设置鼠标光标为一只手*/
  a {
    text-decoration: none !important;
    cursor: pointer !important;
  }
  /* 去掉type为number的箭头 */
  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  /* 自定义单选框样式 */
  #app .el-radio__inner {
    border: 1px solid #827d7d;
    width: 16px;
    height: 16px;
  }
  #app .el-radio__label {
    padding-left: 5px;
  }
  /* 自定义复选框样式 */
  #app .el-checkbox__inner {
    border: 1px solid #827d7d;
    width: 16px;
    height: 16px;
  }
  #app .el-checkbox__inner {
    padding-left: 5px;
  }
  /* 自定义下拉框样式 */
  .el-select-dropdown {
    z-index: 1000000 !important;
  }
  /* 自定义dialog样式 */
  .el-dialog__wrapper::-webkit-scrollbar {
    height: 0;
    width: 0;
    color: transparent;
  }
  .el-dialog {
    border-radius: 10px !important;
    margin: 0 auto !important;
    margin-top: 10vh !important;
    /* 防止超出视窗 */
    /* max-height: calc(98% - 10vh); */
    max-width: calc(100% - 30px);
    /* 实现body内部滚动 */
    /* display: flex;
    flex-direction: column; */
  }
  .el-dialog .el-dialog__header {
    padding: 10px 20px 10px !important;
    /* border-bottom: 1px solid #f4f4f4; */
  }
  .el-dialog .el-dialog__body {
    padding: 5px 25px 30px !important;
    overflow: auto
  }

  /* 自定义富文本编辑器样式 */
  .editorHtml *, .editorBox * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  .editorHtml p, .editorBox p, .editorBox p,
  .editorHtml h1, .editorBox h1, .editorBox h1,
  .editorHtml h2, .editorBox h2, .editorBox h2,
  .editorHtml h3, .editorBox h3, .editorBox h3,
  .editorHtml h4, .editorBox h4, .editorBox h4,
  .editorHtml h5, .editorBox h5, .editorBox h5,
  .editorHtml table, .editorBox table, .editorBox table,
  .editorHtml pre, .editorBox pre .editorBox pre {
    margin: 5px 0;
    line-height: 1.5;
  }
  .editorHtml p:first-child, .editorBox p:first-child {
    display: inline;
    max-width: 100%;
    margin-top: 0;
  }
  .editorHtml table td, .editorHtml table th,
  .editorBox table td, .editorBox table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  .editorBox {
    display: inline-block;
    border: 1px solid #DCDFE6;
    width: 95%;
    word-wrap: break-word; /* 超出宽度换行 */
    line-height: 1.5;
    background-color: white;
    padding: 6px;
    vertical-align: middle;
  }
  .editorHtml {
    display: inline-block;
    line-height: 1.5;
    vertical-align: middle;
  }
  .editorDiv {
    display: none;
    width: 98%;
    vertical-align: middle;
  }
  .editorDiv * {
    z-index: 0 !important;
  }
  .editorDiv .w-e-toolbar, .editorDiv .w-e-toolbar * {
    z-index: 1 !important;
  }
</style>
